
import moment from "moment-timezone";

export default [

    {
        "invoiceNumber": 1.,
        "Sl. No.": "1",
        "Cert. No.": "INTGG299",
        "Integra PoC Updated": "Vinudha",
        "KAM Head": "Vinudha",
       "CustomerName": "Aaron Lipschitz",
        "EMail": "Aaron.Lipschitz@springernature.com",
        "GrpName": "Springer Nature",
        "Original Organization Name": "Palgrave Macmillan",
        "CurrentOrganisation": "Bloomsbury",
        "TreeName": "Indian Kino Tree",
        "Planted during": "September 2016",
        "BotanicalName": "Pterocarpus marsupium",
        "Tamil Name": "Vengai",
        "Name in Tamil": "வேங்கை",
        "First Name": "Aaron",
        "Tree Description": "Pterocarpus marsupium, also known as Malabar kino, Indian kino tree, or vijayasar, is a medium to large, deciduous tree that can grow up to 30 m (98 ft) tall. It is native to India (where it occurs in parts of the Western Ghats and in the forests of Central India), Nepal, and Sri Lanka. Indian kino has many therapeutic and medicinal properties and is used in treating conditions like elephantiasis, diarrhea, leucoderma, rectalgia, cough, dysentery, and grey hair.",
        "undefined": "Moved to Bloomsbury- Suresh's account- he has included please remove from mine"
    },
    {
        "invoiceNumber": 2.,
        "Sl. No.": "2",
        "Cert. No.": "INTGG262",
        "Integra PoC Updated": "Vinudha",
        "KAM Head": "Vinudha",
        "CustomerName": "Adam Micklethwaite",
        "EMail": "adam.micklethwaite@oup.com",
        "GrpName": "Oxford Univ Press",
        "Original Organization Name": "Oxford Univ Press, Education, UK",
        "CurrentOrganisation": "Oxford Univ Press",
        "TreeName": "Droopy Leaf",
        "Planted during": "September 2013",
        "BotanicalName": "Aglaia roxburghii",
        "Tamil Name": "Mani pungan",
        "Name in Tamil": "மணி புங்கன் ",
        "First Name": "Adam",
        "Tree Description": "Aglaia elaeagnoidea, commonly referred to as Priyangu or Droopy Leaf, is an evergreen tree found in dense and moist forests of India. It is known for its medicinal values and used for treating leprosy, inflammations, and other febrile complaints."
    },
    {
        "invoiceNumber": 3.,
        "Sl. No.": "3",
        "Cert. No.": "INTGG1547",
        "Integra PoC Updated": "Vinudha",
        "KAM Head": "Vinudha",
        "CustomerName": "Adam Phelps",
        "EMail": "Adam.Phelps@oup.com",
        "GrpName": "Oxford Univ Press",
        "Original Organization Name": "Oxford Univ Press, ELT, UK",
        "CurrentOrganisation": "Oxford Univ Press",
        "TreeName": "Ironwood tree",
        "Planted during": "November 2019",
        "BotanicalName": "Memecylon umbellatum",
        "Tamil Name": "Kaasan",
        "Name in Tamil": "காசன் ",
        "First Name": "Adam",
        "Tree Description": "Memecylon umbellatum, commonly known as ironwood, Anjani (Tamil, Malayalam) or Alli (Hindi), is a small tree found in India, the Andaman Islands and the coastal region of the Deccan. The leaves contain a yellow dye, a glucoside, which is used for dyeing the robes of Buddhist monks and for colouring reed mats (Dumbara mats). Medicinally, the leaves are said to have anti-diarrhoeal properties. Historically, this plant was burnt as fuel in the production of Wootz steel."
    },
    {
        "invoiceNumber": 4.,
        "Sl. No.": "4",
        "Cert. No.": "INTGG513",
        "Integra PoC Updated": "Vinudha",
        "KAM Head": "Vinudha",
        "CustomerName": "Aine Flaherty",
        "EMail": "Aine.Flaherty@springernature.com",
        "GrpName": "Springer Nature",
        "Original Organization Name": "Palgrave Macmillan",
        "CurrentOrganisation": "Macmillan",
        "TreeName": "Indian Kino Tree",
        "Planted during": "September 2016",
        "BotanicalName": "Pterocarpus marsupium",
        "Tamil Name": "Vengai",
        "Name in Tamil": "வேங்கை",
        "First Name": "Aine",
        "Tree Description": "Pterocarpus marsupium, also known as Malabar kino, Indian kino tree, or vijayasar, is a medium to large, deciduous tree that can grow up to 30 m (98 ft) tall. It is native to India (where it occurs in parts of the Western Ghats and in the forests of Central India), Nepal, and Sri Lanka. Indian kino has many therapeutic and medicinal properties and is used in treating conditions like elephantiasis, diarrhea, leucoderma, rectalgia, cough, dysentery, and grey hair.",
        "undefined": "EX- PHE- Now not working with any of our account"
    },
    {
        "invoiceNumber": 5.,
        "Sl. No.": "5",
        "Cert. No.": "INTGG1489",
        "Integra PoC Updated": "Vinudha",
        "KAM Head": "Vinudha",
        "CustomerName": "Al Troyano",
        "EMail": "atroyano@wiley.com",
        "GrpName": "John Wiley & Sons",
        "Original Organization Name": "John Wiley & Sons",
        "CurrentOrganisation": "John Wiley",
        "TreeName": "Asiatic Tarenna",
        "Planted during": "November 2019",
        "BotanicalName": "Tarenna asiatica",
        "Tamil Name": "Therani",
        "Name in Tamil": "தரணி ",
        "First Name": "Al",
        "Tree Description": "Found in Indian’s western ghats, Asiatic Tarenna is a compact bush to a small tree, up to 6 m tall. Bark is greyish brown, scaly; blaze with orange speckles. The leaves of this tree are used for medicinal purposes. The leaves are ground into a paste and is used to treat inflammation and paralysis."
    },
    {
        "invoiceNumber": 6.,
        "Sl. No.": "6",
        "Cert. No.": "INTGG1831",
        "Integra PoC Updated": "Vinudha",
        "KAM Head": "Vinudha",
        "CustomerName": "Alan Weston",
        "EMail": "alan.weston@oup.com",
        "GrpName": "Oxford Univ Press",
        "Original Organization Name": "Oxford Univ Press, Academic Journals, UK",
        "CurrentOrganisation": "Oxford Univ Press",
        "TreeName": "Dyer's oleander",
        "Planted during": "August 2020",
        "BotanicalName": "Wrightia tinctoria",
        "Tamil Name": "Veppalai",
        "Name in Tamil": "வெப்பாலை ",
        "First Name": "Alan ",
        "Tree Description": "Wrightia tinctoria, commonly called as Dyer's Oleander, is a flowering plant species found in India. This small, deciduous tree is mostly found in the Indian states of Rajasthan, Tamil Nadu, and Madhya Pradesh. A poultice made from the leaves, which has astringent, anti-inflammatory, and antibacterial properties, is effective in treating various skin disorders. It is also a potent antidandruff agent, which is beneficial in treating scalp disorders."
    },
    {
        "invoiceNumber": 7.,
        "Sl. No.": "7",
        "Cert. No.": "INTGG1518",
        "Integra PoC Updated": "Vinudha",
        "KAM Head": "Vinudha",
        "CustomerName": "Ali Kennedy-Gill",
        "EMail": "Ali.Kennedy-Gill@oup.com",
        "GrpName": "Oxford Univ Press",
        "Original Organization Name": "Oxford Univ Press, Education, UK",
        "CurrentOrganisation": "Oxford Univ Press",
        "TreeName": "Indian kino tree",
        "Planted during": "November 2019",
        "BotanicalName": "Pterocarpus marsupium",
        "Tamil Name": "Vengai",
        "Name in Tamil": "வேங்கை",
        "First Name": "Ali",
        "Tree Description": "Pterocarpus marsupium, also known as Malabar kino, Indian kino tree, or vijayasar, is a medium to large, deciduous tree that can grow up to 30 m (98 ft) tall. It is native to India (where it occurs in parts of the Western Ghats and in the forests of Central India), Nepal, and Sri Lanka. Indian kino has many therapeutic and medicinal properties and is used in treating conditions like elephantiasis, diarrhea, leucoderma, rectalgia, cough, dysentery, and grey hair."
    }
]